{
  "translate": "Traducir",
  "done": "Hecho",
  "amount": "Importe",
  "timeline": "Cronología",
  "moneyAvailable": "Efectivo disponible",
  "marketValue": "Total de activos",
  "availableFundsToWithdraw": "Fondos disponibles para retirar",
  "netContributions": "Contribuciones netas",
  "simpleReturnPercent": "RoR simple",
  "timeWeightedReturn": "RoR ponderado por tiempo",
  "moneyWeightedReturn": "RoR ponderado por el dinero",
  "newContribution": "Nuevas contribuciones (hoy)",
  "cashOnHoldToWithdraw": "Efectivo en espera para retirar",
  "cashOnHoldToTrade": "Efectivo en espera para negociar",
  "startDate": "Fecha de inicio",
  "subAccount": "Subcuenta",
  "suspicious": "Sospechoso",
  "notSuspicious": "No sospechoso",
  "suspiciousActivity": "Actividad sospechosa",
  "suspiciousActivityDetected": "Se ha detectado actividad sospechosa",
  "noSuspiciousActivity": "No hay actividad sospechosa",
  "fraudRiskScore": "Puntuación de riesgo de fraude",
  "lastUpdatedBy": "Actualizado por",
  "riskReasons": "Razones de riesgo",
  "clientGroup": "Grupo de clientes",
  "corporation": "Empresa",
  "household": "Hogar",
  "edit": "Editar",
  "accountHighlights": "Aspectos destacados de la cuenta",
  "highlights": "Aspectos destacados",
  "groupEmployer": "Empleador del grupo",
  "groupNumber": "Número de grupo",
  "displaySettledCash": "Efectivo liquidado",
  "displayUnsettledCash": "Efectivo pendiente de liquidación",
  "displayAccountRepCode": "Código de representante",
  "portfolioHighlights": "Aspectos destacados de la cartera",
  "accountNo": "Número de cuenta",
  "accountOwners": "Propietarios",
  "accountOwner": "Propietario",
  "status": "Estado",
  "YTDContributions": "{{label}} en lo que va de año",
  "first60DaysContributions": "{{label}} en los primeros 60 días {{year}}",
  "last10MonthsContributions": "Resto de {{year}}",
  "withdrawalsCurrentYear": "Retiros en el año en curso",
  "minWithdrawalCurrentYear": "Retiro mínimo en el año en curso",
  "maxWithdrawalCurrentYear": "Retiro máximo en el año en curso",
  "YTDDeposits": "Depósitos en lo que va de año",
  "YTDWithdrawals": "Retiros en lo que va del año",
  "governContributions": "Gobierno {{label}}",
  "currentYearContributions": "Año en curso {{label}}",
  "currentYearWithdrawals": "Retiros del año en curso",
  "priorYearContributions": "Año anterior {{label}}",
  "priorYearWithdrawals": "Retiros del año anterior",
  "portfolioFundFacts": "Facts del fondo",
  "languages": {
    "label": "Idioma preferido",
    "english": "Inglés",
    "french": "Francés"
  },
  "languageSelection": {
    "language": "Idioma",
    "languageList": {
      "en": "English",
      "fr": "Français",
      "es": "Español"
    }
  },
  "notificationSettings": {
    "title": "Configuración de notificaciones en el escritorio",
    "options": {
      "inApp": "Dentro de la aplicación",
      "push": "Presionar",
      "email": "Correo electrónico"
    }
  },
  "updateAvatar": {
    "title": "Actualizar avatar"
  },
  "gender": "Género",
  "preferredMethodOfCommunication": {
    "label": "Método de comunicación preferido"
  },
  "bankAccountSelect": {
    "addBank": "Añadir cuenta bancaria",
    "information": {
      "header": "Añadir una cuenta bancaria",
      "title": "Vincule de forma segura sus cuentas bancarias y de inversión para optimizar su experiencia de inversión.",
      "body": "El cifrado de datos a nivel bancario garantiza la protección de su información. No se almacenan credenciales.",
      "addAccountBtn": "Añadir cuenta",
      "addManuallyBtn": "Quiero añadir mi cuenta manualmente"
    },
    "flinks": {
      "addManually": "Quiero añadir mi cuenta manualmente",
      "linkingTimeInfo": "La conexión puede tardar hasta 5 minutos...",
      "linkingRedirectionInfo": "Una vez que su cuenta bancaria se haya vinculado correctamente, será redirigido automáticamente a la pantalla anterior."
    },
    "addBankModal": {
      "title": "Añadir cuenta bancaria",
      "bankAccountName": "Nombre de cuenta bancaria",
      "institutionNumber": "Número de institución",
      "transitNumber": "Número de tránsito",
      "bankAccount": "Cuenta bancaria",
      "inputErrors": {
        "bankAccountNameCannotBeEmpty": "El nombre de la cuenta bancaria no puede estar vacío",
        "institutionNumberCannotBeEmpty": "El número de institución no puede estar vacío",
        "routingNumberCannotBeEmpty": "El número de ruta no puede estar vacío",
        "institutionNumberLength": "El número de institución debe tener 3 dígitos",
        "routingNumberLength": "El número de ruta debe tener 9 dígitos",
        "transitNumberCannotBeEmpty": "El número de tránsito no puede estar vacío",
        "transitNumberLength": "El número de tránsito debe tener 5 dígitos",
        "bankAccountNumberCannotBeEmpty": "El número de cuenta bancaria no puede estar vacío",
        "bankAccountNumberRange": "La cuenta bancaria debe tener entre 5 y 17 dígitos",
        "usBankAccountNumberRange": "La cuenta bancaria debe tener entre 8 y 12 dígitos"
      }
    },
    "addBankManuallyModal": {
      "title": "Añadir cuenta bancaria",
      "subTitle": "Introduzca la información del titular de la cuenta y cargue un cheque anulado de la cuenta que desea añadir",
      "bankAccountName": "Nombre de cuenta bancaria",
      "transitNumber": "Tránsito #",
      "institutionNumber": "Institución #",
      "accountNumber": "Cuenta #",
      "bankAccount": "Cuenta bancaria",
      "addBankAccount": "Añadir cuenta",
      "linkFlinksButton": "Quiero añadir mi cuenta automáticamente",
      "inputErrors": {
        "transitNumber": "Introduzca un número de tránsito válido",
        "accountNumber": "Introduzca un número de cuenta bancaria válido"
      },
      "bankAccountHolderName": "Nombre del titular de la cuenta bancaria (opcional)",
      "bankTransitAddress": "Dirección bancaria (opcional)",
      "bankCountry": "Jurisdicción bancaria",
      "routingNumber": "Enrutamiento #"
    },
    "deleteBankAccountModal": {
      "title": "¿Está seguro?",
      "body": "No podrá recuperar esta cuenta bancaria y tendrá que añadir otra."
    },
    "confirmationDialogTitle": "¿Está seguro?",
    "bankAccountAddedIntegrationToastMessage": "La cuenta bancaria se ha añadido correctamente.",
    "bankAccountAddedToastMessage": "La cuenta bancaria se ha añadido correctamente con el cheque anulado cargado.",
    "bankAccountAddedToastMessageError": "No se puede añadir la cuenta bancaria. Vuelva a intentarlo o póngase en contacto con el servicio de asistencia."
  },
  "address": {
    "title": "Editar - Dirección",
    "unitNumber": "Número de unidad",
    "houseNumber": "Número de calle",
    "streetName": "Nombre de la calle",
    "city": "Ciudad",
    "province": "Provincia",
    "state": "Estado",
    "postal": "Código postal",
    "postcode": "Código postal",
    "zip": "Código postal",
    "jurisdiction": "Jurisdicción",
    "mailAddressCheck": "¿Tiene una dirección postal diferente a su domicilio/dirección legal?",
    "alternateAddressCheck": "¿Tiene alguna dirección alternativa que sea diferente de su dirección postal y domicilio?",
    "line1": "Línea 1",
    "line2": "Línea 2",
    "country": "País",
    "enterYourAddressManually": "Introduzca su dirección manualmente",
    "here": "aquí.",
    "error": {
      "unSupportedCountry": "El país seleccionado no es compatible. Póngase en contacto con su asesor para obtener ayuda",
      "unSupportedProvince": "La provincia seleccionada no es compatible. Póngase en contacto con su asesor para obtener ayuda",
      "suggestionsUnavailable": "Las sugerencias de dirección no están disponibles en este momento. Por favor, introduzca su dirección manualmente."
    },
    "clearAddress": "Borrar dirección"
  },
  "citizenshipInput": {
    "label": "Ciudadanías",
    "searchLabel": "País",
    "updateButton": "ACTUALIZAR"
  },
  "transferTransitions": {
    "initiate": "Iniciar",
    "ready": "Listo",
    "request": "Solicitud",
    "process": "Proceso",
    "reconcile": "Reconciliar",
    "review": "Revisión",
    "fail": "Fallo",
    "cancel": "Cancelar transferencia",
    "cancelReconciled": "Cancelar",
    "reason": "Razón",
    "cancelScheduled": "Cancelar transferencia programada",
    "failtitle": "Transferencia fallida",
    "canceltitle": "Cancelar transferencia",
    "abort": "Abortar",
    "confirm": "Confirmar",
    "flipCancelToReconcile": "Reconciliar transferencia",
    "editScheduled": "Editar transferencia programada"
  },
  "transferTable": {
    "state": "Estado",
    "type": "Tipo",
    "source": "Fuente"
  },
  "tradeTransitions": {
    "process": "Proceso",
    "reconcile": "Reconciliar",
    "fail": "Fallo",
    "cancel": "Cancelar",
    "forceCancel": "Cancelar",
    "cancelReconciled": "Cancelar"
  },
  "reportTransitions": {
    "review": "Revisión",
    "approved": "Aprobado",
    "denied": "Denegado"
  },
  "loginSettings": {
    "title": "Gestionar inicio de sesión",
    "changePassword": "Cambiar contraseña",
    "resetPasswordSuccess": "Le hemos enviado un correo electrónico para restablecer su contraseña."
  },
  "activityTable": {
    "client": "Cliente",
    "account": "Cuenta",
    "accountType": "Tipo de cuenta",
    "type": "Tipo",
    "source": "Fuente",
    "sourceId": "ID de origen",
    "amount": "Importe",
    "state": "Estado",
    "autoTransfer": "Transferencia automática",
    "frequency": "Frecuencia",
    "nextScheduledDate": "Próxima fecha programada",
    "createdAt": "Creado",
    "reconciledAt": "Reconciliado",
    "actions": "Acciones",
    "alertState": "Estado de alerta",
    "alert": "Alerta",
    "alertDescription": "Descripción",
    "fraudRisk": "Puntuación FinCrime",
    "noTransfersExist": "No hay transferencias disponibles",
    "noTransfersExistWithFilter": "No hay transferencias que coincidan con los criterios del filtro",
    "noScheduledTransfersExist": "No tiene ninguna transferencia programada",
    "noUpcomingTransfersExist": "No tiene ninguna transacción pendiente",
    "noScheduledIncomeFundTransfersExist": "No hay transferencias disponibles del Fondo de ingresos programados",
    "dob": "Fecha de nacimiento",
    "depositTo": "Depósito a",
    "paymentType": "Tipo de pago",
    "instantInvest": "Inversión instantánea",
    "initiatedByRepresentative": "Iniciado por el representante",
    "organization": "Organización",
    "scheduledDate": "Fecha prevista",
    "bankAccount": "Cuenta bancaria",
    "bankAccountId": "ID de cuenta bancaria",
    "subAccount": "Subcuenta",
    "failReason": "Motivo del fallo",
    "user": "Usuario",
    "userFirstName": "Nombre del usuario",
    "userMiddleName": "Segundo nombre del usuario",
    "userLastName": "Apellido del usuario",
    "endDate": "Fecha de finalización",
    "toSubAccount": "A la subcuenta",
    "transferAll": "Transferir todo",
    "withdrawalReason": "Motivo de la retirada",
    "withdrawalReasonDescription": "Descripción del motivo de la retirada",
    "subAccountGoalName": "Nombre de meta de subcuenta",
    "subAccountAccountType": "Tipo de subcuenta",
    "unrealizedGainsAndLossCents": "Ganancias y pérdidas no realizadas (centavos)",
    "unrealizedGainsAndLossCentsPercentage": "Ganancias y pérdidas no realizadas (porcentaje)",
    "accountFileName": "Cuentas",
    "lastSkippedAt": "Último omitido",
    "lastSkipReason": "Motivo de la última omisión"
  },
  "custodianActivities": {
    "exportProgressTitle": "Exportación de actividades externas",
    "title": "Actividades de custodia",
    "accountId": "ID de cuenta",
    "accountType": "Tipo de cuenta",
    "accountNumber": "Número de cuenta",
    "transactionType": "Tipo de transacción",
    "transactionDesc": "Descripción",
    "currency": "Moneda",
    "security": "Seguridad",
    "quantity": "Cantidad",
    "price": "Precio",
    "amount": "Importe",
    "state": "Estado",
    "effectiveDate": "Fecha de entrada en vigor",
    "processDate": "Fecha del proceso",
    "settleDate": "Fecha de liquidación",
    "modal": {
      "activityDetails": "Detalles de la actividad",
      "reconcileButton": "Reconciliar",
      "forceReconcileButton": "Reconciliación forzada"
    }
  },
  "transfers": {
    "title": "Transferencias",
    "exportProgressTitle": "Exportación de transferencias",
    "exportProgressTitleOneOff": "Exportación de transferencias",
    "exportProgressTitleScheduled": "Exportación de transferencias programadas",
    "transferDetails": "Detalles de la transferencia",
    "transferProgress": "Progreso de la transferencia",
    "source": "Fuente",
    "date": "Fecha prevista",
    "frequency": "Frecuencia",
    "setState": "Establecer estado",
    "confirmationDialog": {
      "cancelScheduled": "Esto cancelará todas las transferencias futuras programadas para esta serie. ¿Desea continuar?",
      "cancel": "Esto cancelará la transferencia. ¿Desea continuar?"
    },
    "cancel": "No, mantener la transferencia",
    "confirm": "Sí, cancelar transferencia",
    "transitionSuccess": "Estado de transferencia cambiado correctamente",
    "cancelTransferSuccess": "Transferencia cancelada correctamente",
    "cancelScheduledTransferSuccess": "Transferencia programada cancelada correctamente",
    "createAdjustmentTransfer": "Agregar",
    "createAdjustmentTransferTitle": "Crear transferencia de ajuste",
    "lastSkipped": "Último omitido",
    "lastSkippedOn": "Último omitido el {{date}}",
    "lastSkipReason": "Motivo de omisión"
  },
  "transferUpdate": {
    "sourceIdRequired": "Se requiere el ID de origen",
    "bankAccountIdRequired": "Se requiere ID de cuenta bancaria"
  },
  "transfersTable": {
    "tableHeader": "Transferencias",
    "scheduleTableHeader": "Transferencias programadas",
    "paymentInstructions": "Instrucciones de pago",
    "yes": "Sí",
    "no": "No",
    "frequencyOption": {
      "ONE_TIME": "Único",
      "DAILY": "Diario",
      "WEEKLY": "Semanal",
      "SEMI_MONTHLY": "Dos veces al mes",
      "MONTHLY": "Mensual",
      "BI_WEEKLY": "Quincenal",
      "QUARTERLY": "Trimestral"
    },
    "addTransfer": "Añadir transferencia",
    "userFirstName": "Nombre del usuario",
    "userLastName": "Apellido del usuario",
    "account": "ID de cuenta",
    "subAccount": "ID de subcuenta",
    "bankAccount": "ID de cuenta bancaria",
    "custodianAccountNumber": "Número de cuenta de custodio",
    "dividendFor": "Dividendo para",
    "source": "Fuente",
    "sourceId": "ID de origen",
    "value:": "Valor",
    "createdAt": "Creado",
    "reconciledAt": "Reconciliado"
  },
  "trades": {
    "title": "Transacciones",
    "tradeDetails": "Detalles de la transacción",
    "exportProgressTitle": "Exportación de transacciones",
    "tradeProgress": "Progreso comercial",
    "quantity": "Cantidad",
    "estimatedQuantity": "Cantidad estimada",
    "security": "Seguridad",
    "symbol": "Símbolo",
    "price": "Precio",
    "estimatedPrice": "Precio estimado"
  },
  "tradeTable": {
    "noTradesExist": "No tiene ninguna orden comercial",
    "client": "Cliente",
    "account": "Cuenta",
    "custodianAccountNumber": "Número de cuenta de custodio",
    "type": "Tipo",
    "security": "Seguridad",
    "quantity": "Cantidad",
    "price": "Precio",
    "actualQuantity": "Cantidad actual",
    "actualPrice": "Precio actual",
    "expectedQuantity": "Cantidad prevista",
    "expectedPrice": "Precio esperado",
    "expectedTotalValue": "Valor comercial",
    "totalValue": "Valor",
    "state": "Estado",
    "tradeDate": "Fecha de la transacción",
    "settlementDate": "Fecha de liquidación",
    "createdAt": "Creado",
    "reconciledAt": "Reconciliado",
    "actions": "Acciones",
    "cancel": "Cancelar",
    "remove": "Eliminar de la ejecución de operaciones masivas",
    "currency": "Moneda",
    "rebalance": "Reequilibrar",
    "user": "Usuario",
    "userFirstName": "Nombre del usuario",
    "userLastName": "Apellido del usuario",
    "organization": "Organización"
  },
  "bulkTradeRunAllocationsTable": {
    "externalId": "Identificación externa",
    "account": "Cuenta",
    "settlementCurrency": "Moneda de liquidación",
    "tradeCurrency": "Moneda comercial",
    "side": "Lado",
    "symbol": "Símbolo",
    "market": "Mercado",
    "fillPrice": "Precio de relleno",
    "shareQuantity": "Cantidad de acciones",
    "tradeDate": "Fecha de la transacción",
    "settlementDate": "Fecha de liquidación",
    "tradeValue": "Valor comercial",
    "corporateOffsetAccount": "Cuenta corporativa de compensación",
    "fXRate": "Tipo de cambio"
  },
  "any": "Cualquiera",
  "close": "Cerrar",
  "type": "Tipo",
  "filter": "Filtro",
  "fromDate": "Desde",
  "toDate": "A",
  "security": "Seguridad",
  "upcomingTransaction": {
    "fileName": "Próximas transacciones",
    "progressTitle": "Empaquetar próximas transacciones",
    "errorStateTitleUpcomingTransactions": "No se pueden cargar las transacciones"
  },
  "transaction": {
    "title": "Transacciones anteriores",
    "noTransactions": "No tiene ninguna transacción anterior",
    "errorStateTitleLedgerTransactions": "No se pueden cargar las transacciones",
    "noTransactionsExistWithFilter": "No hay transacciones que coincidan con los criterios del filtro",
    "fileName": "transacciones",
    "progressTitle": "Empaquetando transacciones",
    "exportProgressTitle": "Exportación de transacciones",
    "requested": "Solicitado",
    "reconciled": "Reconciliado",
    "pendingConfirmation": "Pendiente de confirmación",
    "expectedSettlementDate": "Fecha prevista para la liquidación: {{settlementDate}}",
    "estimateFinalValue": "La estimación puede no ser el valor definitivo",
    "table": {
      "client": "Cliente",
      "account": "Cuenta",
      "accountType": "Tipo de cuenta",
      "type": "Tipo",
      "switchType": "Cambiar el tipo",
      "quantity": "Cantidad",
      "valueCents": "Valor",
      "date": "Fecha",
      "initiatedDate": "Fecha de inicio",
      "processedDate": "Fecha procesada",
      "description": "Detalles",
      "actions": "Acciones",
      "state": "Estado",
      "source": "Fuente",
      "goal": "Meta",
      "frequency": "Frecuencia",
      "priceCents": "Precio de coste",
      "bookCost": "Coste del libro (ACB/unidad)",
      "bookValue": "Valor contable",
      "currency": "Moneda",
      "settleDate": "Fecha de liquidación",
      "settleDateToWithdraw": "Fecha de liquidación para retirar",
      "subAccount": "Subcuenta",
      "user": "Usuario",
      "userFirstName": "Nombre del usuario",
      "userLastName": "Apellido del usuario",
      "organization": "Organización",
      "objectType": "Tipo de objeto",
      "objectId": "Identificador del objeto",
      "householdClientGroup": "Grupo de clientes domésticos"
    },
    "actions": {
      "update": "Actualizar",
      "delete": "Eliminar"
    },
    "types": {
      "EFT": "EFT",
      "CANCEL_EFT": "EFT cancelado",
      "BUY": "Operación de compra",
      "CANCEL_BUY": "Operación de compra cancelada",
      "SELL": "Operación de venta",
      "CANCEL_SELL": "Operación de venta cancelada",
      "DIVIDEND": "Dividendo",
      "EXTERNAL_TRANSFER_IN": "Transferencia externa entrante",
      "EXTERNAL_TRANSFER_OUT": "Transferencia externa saliente",
      "TRANSFER_IN": "De otra cartera",
      "TRANSFER_OUT": "A otra cartera",
      "CANCEL_TRANSFER": "Transferencia cancelada",
      "CORPORATE_ACTION": "Acción corporativa",
      "CANCEL_CORPORATE_ACTION": "Acción corporativa cancelada",
      "MANAGEMENT_FEE": "Comisión de gestión",
      "CANCEL_MANAGEMENT_FEE": "Comisión de gestión cancelada",
      "BORROW_FEE": "Tarifa de préstamo",
      "MISC_FEE": "Tarifa miscelánea",
      "INTEREST": "Interés",
      "RISK_EXPOSURE_FEE": "Comisión por exposición al riesgo",
      "WITHHOLDING_TAX": "Retención fiscal",
      "DEREGISTRATION_FEE": "Tasa de baja",
      "DEREGISTRATION_TAX": "Impuesto de baja",
      "GST": "GST",
      "HST": "HST",
      "ADJUSTMENT": "Ajuste",
      "GOV_CONTRIBUTIONS": "Contribuciones gubernamentales",
      "SWITCH_IN": "Cambiar",
      "CANCEL_SWITCH_IN": "Cancelar cambio",
      "CANCEL_SWITCH_OUT": "Cancelar cambio",
      "DISTRIBUTION": "Distribución",
      "CHEQUE": "Cheque",
      "DEPOSIT_BUY": "Depósito de compra",
      "DISTRIBUTION_REINVESTMENT": "Reinversión de la distribución",
      "EXTERNAL_TRANSFER_IN_SECURITY": "Transferencia externa en seguridad",
      "EXPENSE": "Gasto",
      "OTHER": "Otros",
      "TRANSFER_IN_SECURITY": "Transferencia entrante de seguridad",
      "TRANSFER_OUT_SECURITY": "Transferencia saliente de seguridad",
      "SWITCH_OUT": "Cambiar",
      "SWI_MARKET": "Mercado SWI",
      "SWI_COST": "Coste SWI",
      "SWO_MARKET": "Mercado SWO",
      "SWO_COST": "Coste SWO",
      "MARKET_DRIP": "Goteo del mercado",
      "CUSTODY_FEE": "Tarifa de custodia",
      "INCOME_FUND_TRANSFER": "Transferencia de fondos de ingresos",
      "ACCRUED_INTEREST": "Intereses devengados",
      "CANADA_LEARNING_BOND": "Bono de aprendizaje de Canadá",
      "COMMISSION": "Comisión",
      "DISABILITY_ASSISTANCE_PAYMENT": "Pago de asistencia por discapacidad",
      "ADD_CAD_EDU_SAVING_GRANT": "Subvención adicional para el ahorro en educación en Canadá",
      "HOME_BUYER_PLAN": "Plan para compradores de vivienda",
      "LIFE_LEARNING_PLAN": "Plan de aprendizaje para la vida",
      "MANAGEMENT_FEE_REDEMPTION": "Comisión de gestión de reembolso",
      "REBATE": "Descuento",
      "REDEMPTION": "Redención",
      "RETURN_OF_CAPITAL": "Devolución de capital",
      "WIRE_TRANSFER": "Transferencia bancaria",
      "WRITE_OFF": "Cancelar",
      "STOCK_DRIP": "Goteo de existencias",
      "CANCEL_BORROW_FEE": "Cancelar tarifa de préstamo",
      "CANCEL_CHEQUE": "Cancelar cheque",
      "CANCEL_DEPOSIT": "Cancelar depósito",
      "CANCEL_FEE": "Tarifa de cancelación",
      "CANCEL_HST": "Cancelar HST",
      "CANCEL_INTEREST": "Cancelar interés",
      "CANCEL_REBATE": "Cancelar reembolso",
      "CANCEL_TRANSFER_IN": "Cancelar transferencia en seguridad",
      "CANCEL_TRANSFER_OUT": "Cancelar transferencia de seguridad",
      "FEDERAL_TAX": "Impuesto federal",
      "SHORT_TERM_GAIN_LOSS": "Ganancias y pérdidas a corto plazo",
      "LONG_TERM_GAIN_LOSS": "Ganancias y pérdidas a largo plazo",
      "NON_EDU_CAPITAL_WITHDRAWAL": "Retirada de capital no educativo",
      "CANCEL_ADJUSTMENT": "Cancelar ajuste",
      "CONTRIBUTION": "Contribución",
      "BOOK_VALUE_ADJUSTMENT": "Ajuste del valor contable",
      "DSC_FEE": "Comisión DSC",
      "JOURNAL": "Asiento",
      "CANCEL_JOURNAL": "Cancelar asiento",
      "FOREIGN_TAX": "Impuesto extranjero",
      "TRANSFERS_EXCHANGES": "Transferencias / Intercambios"
    },
    "currencies": {
      "CAD": "CAD",
      "USD": "USD"
    },
    "switchMenuItem": {
      "SWITCH": "Cambiar"
    },
    "switchTypes": {
      "AT_COST": "A precio de coste",
      "AT_MARKET": "Del mercado"
    },
    "newTransaction": {
      "createdToastMessage": "Se ha creado la transacción de ajuste.",
      "title": "Nueva transacción",
      "portfolio": "Cartera",
      "date": "Fecha",
      "amount": "Importe",
      "details": "Detalles",
      "financialProduct": "Producto",
      "quantity": "Cantidad",
      "price": "Precio",
      "adjustmentType": "Tipo de ajuste",
      "interestType": "Tipo de interés",
      "adjustedCostBase": "Base de costos ajustados",
      "interestTypes": {
        "DEPOSIT": "Ingresos por intereses",
        "WITHDRAW": "Intereses cobrados"
      },
      "security": "Seguridad",
      "bookValue": "Valor contable",
      "invalidDescription": "La descripción contiene caracteres no válidos",
      "journalCreatedToastMessage": "Se han creado las transacciones de asiento.",
      "errorToastMessage": "No se pudo crear la transacción. Inténtelo de nuevo.",
      "pricePerUnit": "Precio por unidad",
      "journalType": "Tipo de asiento",
      "toSubAccount": "A la subcuenta",
      "additionalCash": "Efectivo adicional",
      "noValidTargetSubAccounts": "No hay subcuentas válidas disponibles para la transferencia. Seleccione una cartera diferente que tenga otras subcuentas en la misma cuenta con la misma moneda.",
      "noSecurityHoldings": "Esta cartera no tiene valores disponibles para la transferencia. Solo las carteras con valores pueden utilizarse para transacciones de asiento de VALORES o AMBOS.",
      "priceExceedsHoldingValue": "Precio × Cantidad excede el valor disponible de las tenencias",
      "currentMarketPrice": "Precio actual de mercado: {{price}}",
      "executionOrder": "Orden de ejecución",
      "executionOrderHelp": "Orden de procesamiento de transacciones para transacciones de la misma fecha (0=primero, 1=segundo)"
    },
    "switchTransaction": {
      "outSecurity": "Cambiar salida de la seguridad",
      "inSecurity": "Cambiar entrada en la seguridad",
      "switchInPrice": "Cambiar en ACB",
      "valueCents": "Valor total de mercado",
      "quantity": "Cantidad",
      "priceCents": "Cambiar ACB",
      "switchedToastMessage": "Se han creado transacciones de cambio.",
      "isExistingHolding": "La seguridad del cambio se mantiene actualmente en esta cartera.",
      "atCostInfo": "El precio por unidad del cambio de seguridad es el coste total de la seguridad sustituida / cantidad incorporada.",
      "atMarketInfo": "El precio por unidad del cambio de seguridad es su precio actual de mercado."
    },
    "updateTransaction": {
      "title": "Actualizar transacción",
      "updatedToastMessage": "La transacción se ha actualizado.",
      "pendingWarning": "Esta transacción está actualmente pendiente y no se puede modificar.",
      "errorToastMessage": "No se pudo actualizar la transacción. Inténtelo de nuevo."
    },
    "deleteTransaction": {
      "deletedToastMessage": "La transacción ha sido eliminada.",
      "title": "Eliminar transacción",
      "body": "¿Está seguro de que desea eliminar esta transacción?",
      "journalDeletedToastMessage": "Se han eliminado las transacciones de asiento.",
      "errorToastMessage": "No se pudo eliminar la transacción. Inténtelo de nuevo."
    },
    "journalTypes": {
      "CASH": "Solo efectivo",
      "SECURITY": "Solo valores",
      "BOTH": "Valores + Efectivo"
    }
  },
  "transferSources": {
    "USER": "Iniciado por el cliente",
    "REPRESENTATIVE": "Iniciada por el representante",
    "FEE": "Comisión de gestión",
    "DEREGISTRATION": "Tasa de baja",
    "DEREGISTRATION_TAX": "Impuesto de baja",
    "WITHHOLDING_TAX": "Retención fiscal",
    "DIVIDEND": "Dividendo",
    "TO_SUB_ACCOUNT": "A otra cartera",
    "FROM_SUB_ACCOUNT": "De otra cartera",
    "TO_ACCOUNT": "A otra cuenta",
    "FROM_ACCOUNT": "De otra cuenta",
    "EXTERNAL_TRANSFER_IN": "Transferencia externa entrante",
    "EXTERNAL_TRANSFER_OUT": "Transferencia externa saliente",
    "ADJUSTMENT": "Ajuste",
    "CUSTODIAN_ACTIVITY": "Actividad del custodio",
    "GOV_CONTRIBUTIONS": "Contribuciones gubernamentales",
    "INCOME_FUND_TRANSFER": "Transferencia de fondos de ingresos",
    "CHEQUE": "Cheque",
    "DISTRIBUTION": "Distribución",
    "DSC_FEE": "Comisión DSC"
  },
  "transferTo": "A {{subAccount}}",
  "transferFrom": "Desde {{subAccount}}",
  "ruleTypes": {
    "ABOVE_LIQUIDITY": "Liquidez superior",
    "ABOVE_NETWORTH": "Por encima del patrimonio neto",
    "ADVERSE_NEWS": "Noticias adversas",
    "DEPOSIT_IN_SAME_TIMEFRAME": "Depósito en el mismo plazo",
    "DORMANT_ACCOUNT": "Cuenta inactiva",
    "FOR_ACCOUNT_PURPOSE": "Para fines contables",
    "HIGH_RISK_USER": "Usuario de alto riesgo",
    "LARGE_DEPOSIT": "Gran depósito",
    "LARGE_EXTERNAL_TRANSFER": "Transferencia externa grande",
    "LARGE_WITHDRAW_IN_SHORT_TIME": "Gran retirada en poco tiempo",
    "MULTIPLE_DEPOSIT_IN_SHORT_TIME": "Múltiples depósitos en poco tiempo",
    "HAS_MULTIPLE_LARGE_DEPOSITS": "Múltiples depósitos de gran cuantía",
    "HAS_MULTIPLE_LARGE_WITHDRAWALS": "Múltiples retiradas de grandes cantidades",
    "LARGE_WITHDRAWAL": "Retirada importante",
    "WITHDRAWAL_TO_NEW_BANK_ACCOUNT": "Retirada a nueva cuenta bancaria"
  },
  "alertReportStates": {
    "INITIATED": "Iniciado",
    "REVIEW": "Revisión",
    "APPROVED": "Aprobado",
    "DENIED": "Denegado"
  },
  "subAccountTable": {
    "account": "Cuenta",
    "goal": "Meta",
    "theme": "Tema",
    "suggestedPortfolio": "Cartera sugerida",
    "portfolio": "Cartera",
    "requireIPS": "Requerir IPS",
    "allowClientDeposits": "Depósitos de clientes permitidos",
    "allowFractionalShares": "Permitir acciones fraccionadas",
    "nextDeposit": "Próximo depósito",
    "assets": "Total de activos",
    "state": "Estado",
    "actions": "Acciones",
    "Yes": "Sí",
    "No": "No",
    "True": "Verdadero",
    "False": "Falso"
  },
  "subAccountState": {
    "AWAITING_APPROVAL": "En espera de aprobación",
    "ACTIVE": "Activo",
    "INACTIVE": "Cerrado",
    "WITHDRAW_ALL": "Retirar todo"
  },
  "subAccountTransitions": {
    "activate": "Activar",
    "review": "Revisión",
    "deactivate": "Desactivar"
  },
  "scheduledFundTransferModal": {
    "warningToastMessage": "Ya tiene una transferencia programada en {{content}}, por favor, cancele la transferencia en esta cuenta antes de crear otra.",
    "editTitle": "Editar instrucciones de pago",
    "title": "Nuevas instrucciones de pago",
    "edit": "Editar",
    "archive": "Archivar",
    "years": "años",
    "dateOfBirth": "Edad para calcular el pago mínimo",
    "typeOfAnnualPaymentAmount": "Tipo de importe del pago anual",
    "amountPayableType": "Tipo de importe",
    "schedule": "Calendario de pagos",
    "scheduledDate": "Fecha prevista",
    "scheduleOptions": {
      "SEMI_ANNUALLY": "Semestral",
      "QUARTERLY": "Trimestral",
      "ANNUALLY": "Anual",
      "MONTHLY": "Mensual"
    },
    "annualAmountCents": "Importe anual en céntimos",
    "amount": "Importe",
    "typeOfAnnualPaymentAmountSources": {
      "custom": "Personalizado",
      "minimumAnnualPayment": "Pago mínimo anual"
    },
    "amountPayableTypeSources": {
      "gross": "BRUTO",
      "net": "NETO"
    },
    "starting": "Inicio",
    "taxOptionType": "Tipo de opción fiscal",
    "taxOptions": {
      "NO_TAX_ON_MINIMUM": "Sin impuestos sobre el mínimo",
      "SPECIAL_TAX_RATE": "Tipo impositivo especial",
      "TAX_ON_FULL": "Impuesto sobre el total"
    },
    "subAccount": "Subcuenta",
    "bankAccount": "Pago del depósito a",
    "specialTaxRate": "Tipo impositivo especial"
  },
  "transferModal": {
    "title": "Nueva transferencia",
    "updateTitle": "Actualizar transferencia",
    "updateBtnTitle": "Actualizar",
    "schedule": "Calendario",
    "starting": "Inicio",
    "scheduleOptions": {
      "ONE_TIME": "Solo por esta vez",
      "WEEKLY": "Semanal",
      "BI_WEEKLY": "Quincenal",
      "MONTHLY": "Mensual",
      "QUARTERLY": "Trimestral",
      "SEMI_MONTHLY": "Dos veces al mes"
    },
    "startingOptions": {
      "now": "Ahora",
      "futureDate": "Fecha futura"
    },
    "sources": {
      "adjustment": "Ajuste",
      "eft": "EFT",
      "ALL_IN_CASH": "Completo",
      "PARTIAL_CASH": "Parcial",
      "ALL_IN_KIND": "Totalmente en especie",
      "externalTransferIn": "Transferencia externa entrante",
      "transferToSubAccount": "Transferir a otra cartera",
      "cheque": "Cheque"
    },
    "externalTransfer": {
      "method": "Método de transferencia",
      "allInCash": "Todo en efectivo",
      "partialCash": "Efectivo parcial",
      "allInKind": "Todo en especie",
      "institution": "Institución",
      "transferAccountNumber": "Número de cuenta de transferencia",
      "relinquishingInstitution": "Institución cedente",
      "accountTypeAndNumber": "Cuenta (tipo, número)",
      "account": "Cuenta",
      "signedTransferForm": "formulario de transferencia firmado",
      "downloadSignedTransferForm": "Descargar formulario de transferencia firmado",
      "signedTransferFormBtnText": "Formulario de transferencia firmado"
    },
    "type": "Tipo",
    "source": "Fuente",
    "deposit": "Depositar",
    "withdraw": "Retirar",
    "portfolio": "Cartera",
    "fromPortfolio": "De cartera",
    "toPortfolio": "A cartera",
    "bankAccount": "Cuenta bancaria",
    "amount": "Importe",
    "totalTransferAmount": "Importe total de la transferencia",
    "clbTransferAmount": "Importe de la transferencia CLB",
    "bcGrantTransferAmount": "Importe de la transferencia de la subvención de BC",
    "transferAll": "Transferir todos los fondos",
    "withdrawAll": "Retirar todo",
    "exceedWithdrawAllWarning": "Se tratará de una retirada completa en la que se venderán todos los valores y los fondos se enviarán a la cuenta bancaria que usted elija. Por favor, marque esto como una retirada total o reduzca la cantidad.",
    "exceedTransferAllWarning": "Se tratará de una transferencia completa en la que se venderán todos los valores y los fondos se enviarán a la cartera que usted elija. Por favor, marque esta operación como una transferencia de todos los fondos o reduzca el importe.",
    "adjustmentReason": "Motivo del ajuste",
    "createdToastMessage": "La transferencia se ha creado.",
    "fetchingFees": "Tarifas de búsqueda...",
    "eftOut": "EFT saliente",
    "withdrawalMode": "Modo de retirada",
    "gross": "Bruto",
    "net": "Neto",
    "netAmount": "Importe neto",
    "minRecurringDepositAmount": "Este es el importe mínimo de depósito programado:",
    "minAmountDeposit": "Este es el importe mínimo de su depósito:",
    "minInitialDeposit": "Este es el importe mínimo de su depósito inicial:",
    "depositGreaterThanZero": "El importe del depósito debe ser superior a 0",
    "selectScheduleFirst": "Por favor seleccione un horario para continuar",
    "insufficientCurrencyBalance": "Saldo insuficiente en {{currency}}. Disponible: {{available}}",
    "stateTaxTitle": "Tasa de retención del impuesto estatal",
    "federalTaxTitle": "Tasa de retención del impuesto federal",
    "availableCash": "Disponible: {{amount}}",
    "availableQuantity": "Disponible: {{quantity}} acciones",
    "availableValue": "Disponible: {{amount}}",
    "choosePortfolio": "Elegir cartera",
    "feeSourceNotSetToastMessage": "Se creó el ajuste, pero no se pudo establecer la fuente de la comisión de gestión. Edite la transferencia para establecerla."
  },
  "tradeModal": {
    "title": "Nueva transacción",
    "types": {
      "buy": "Comprar",
      "sell": "Vender"
    },
    "type": "Tipo",
    "portfolio": "Cartera",
    "financialProduct": "Producto",
    "price": "Precio / Base de costos ajustados",
    "quantity": "Cantidad",
    "effectiveDate": "Fecha de entrada en vigor",
    "description": "Descripción",
    "createdToastMessage": "Se ha creado la transacción.",
    "fractionalToastMessage": "Este producto no permite operaciones fraccionadas.",
    "isReconciled": "Transacción reconciliada",
    "createExternalTransfer": "Crear transferencia externa equivalente para transferencia en especie"
  },
  "goalType": {
    "CAR": "Coche",
    "BUILD_WEALTH": "Generar riqueza",
    "RETIREMENT": "Jubilación",
    "MAJOR_PURCHASE": "Compra importante",
    "HOUSE": "Casa",
    "EDUCATION": "Educación",
    "VACATION": "Vacaciones",
    "START_A_BUSINESS": "Iniciar un negocio",
    "WEDDING": "Boda",
    "PARENTAL_LEAVE": "Licencia parental",
    "SAFETY_NET": "Red de seguridad",
    "OTHER": "Otros"
  },
  "taxInformationField": {
    "label": "Paga impuestos extranjeros",
    "country": "País",
    "tin": "Número de identificación fiscal"
  },
  "externalInstitutionSelect": {
    "selectInstitutionDialog": {
      "title": "Seleccionar institución financiera",
      "addManually": "+ Añadir institución manualmente",
      "addInstitution": "+ Añadir nueva institución"
    },
    "addInstitutionDialog": {
      "title": "Añadir institución manualmente",
      "institutionNameLabel": "Nombre de la institución",
      "addManually": "+ Añadir institución manualmente"
    },
    "confirmButton": "Confirmar"
  },
  "scheduleDateSelect": {
    "title": "Uno de los...",
    "label": "Fecha prevista",
    "suffix": "día del mes"
  },
  "booleanOptions": {
    "yes": "Sí",
    "no": "No"
  },
  "simpleDateRangePicker": {
    "fromDate": "Desde",
    "toDate": "A"
  },
  "portfolio": "Cartera",
  "viewPreTradePositions": "Ver valor de mercado de las posiciones previas a la negociación",
  "viewInactiveSubAccounts": "Ver subcuentas inactivas",
  "portfolioLastUpdated": "Última actualización {{date}}",
  "portfolioFxRate": "Tipo de cambio {{from}} a {{to}}: {{fxRate}}",
  "portfolioWarnings": {
    "accountIsBlocked": "Las operaciones no se ejecutarán porque la cuenta no está activa y/o aprobada",
    "subAccountIsBlocked": "Las operaciones no se ejecutarán porque la subcuenta no está activa y/o aprobada",
    "illiquidProducts": "Las operaciones con productos ilíquidos solo estarán disponibles para su negociación en la(s) próxima(s) fecha(s) programada(s): {{datesAndTickers}}",
    "pendingTransactionUsdCurrency": "Las órdenes de negociación de valores en USD {{tickers}} se han ejecutado, pero están pendientes de conciliación y pueden diferir del importe mostrado",
    "pendingTransactionMfSellAll": "Vender todas las órdenes de fondos de inversión {{tickers}} se han ejecutado, pero están pendientes de conciliación y pueden diferir del importe mostrado",
    "pendingSplitsInCompletedTrades": "Hay divisiones pendientes en la tabla de operaciones completadas."
  },
  "bulkTradeRequestIsNotFound": "Error: ¡No se ha encontrado la solicitud de operación masiva asociada al optimizador de cartera actual!",
  "errorOccurredWhileLoadingPortfolio": "¡Se ha producido un error al cargar la cartera!",
  "errorPortfolioViewUnderSubAccount": "Por favor, vea la cartera en la subcuenta",
  "errorPortfolioViewUnderGoal": "Por favor, vea la cartera en la meta",
  "revert": "Revertir",
  "autoFillToTarget": "Autocompletar para el destino",
  "autoRebalance": "Reequilibrio automático",
  "optimizer": "Optimizador",
  "optimizerDisabledReason": "El optimizador no está disponible debido a transacciones pendientes activas",
  "showPairs": "Mostrar pares",
  "canadianCash": "Dólares canadienses",
  "pendingReconciliationAlerts": {
    "usdSecurityMessage": "Las órdenes de negociación de valores en USD {{tickers}} se han ejecutado, pero están pendientes de conciliación y pueden diferir del importe mostrado",
    "mfSellAllMessage": "Vender todas las órdenes de fondos de inversión {{tickers}} se han ejecutado, pero están pendientes de conciliación y pueden diferir del importe mostrado"
  },
  "portfolioTable": {
    "assetGroup": "Grupo de activos",
    "collapseRow": "Contraer fila",
    "expandRow": "Expandir fila",
    "deleteAssetClass": "Eliminar clase de activo",
    "security": "Seguridad",
    "current": "Actual",
    "target": "Meta",
    "original": "Original: {{amount}}",
    "pendingWithdraw": "Retirada pendiente: {{amount}}",
    "deviation": "Desviación",
    "cash": "Efectivo",
    "total": "Total",
    "taxRank": "Clasificación fiscal",
    "subAccountIsInactive": "Esta subcuenta está inactiva y no se pueden realizar operaciones con ella",
    "pendingReconciliation": "Reconciliación pendiente",
    "initiatedBuy": "Comprar",
    "initiatedSell": "Vender",
    "initiatedSellAll": "Vender todo",
    "requestedBuy": "Comprar",
    "requestedSell": "Vender",
    "requestedSellAll": "Vender todo",
    "sellAll": "VENDER TODO",
    "settles": "Liquida",
    "settling": "Liquidando"
  },
  "noRecordsFound": "No se encontraron registros",
  "generateTrades": {
    "confirmTrades": "Confirmar operaciones",
    "completeTrades": "Lote completo",
    "cancelTrades": "Cancelar todas las operaciones",
    "cancelSelectedTrades": "Cancelar operaciones seleccionadas",
    "exportTrades": "Exportación de transacciones",
    "nothingToExport": "No hay nada que exportar",
    "verifyTradesResult": "Las transacciones se marcaron como verificadas",
    "unverifyTradesResult": "Las transacciones se marcaron como no verificadas",
    "verifyUnverifyTradesResult": "Las transacciones se marcaron como verificadas/no verificadas",
    "confirm": "Confirmar",
    "tradesSent": "Operaciones enviadas",
    "activeTradeRequests": "Solicitudes de operaciones activas",
    "completedTradeRequests": "Solicitudes de operaciones completadas",
    "generatedByPortfolioOptimizer": "Generado por un optimizador de cartera el {{portfolioOptimizerCreatedAt}}",
    "noActiveTradeRequests": "No hay solicitudes de transacción activas",
    "noCompletedTradeRequests": "No hay solicitudes de transacción completadas",
    "tradesToBeCanceled": "Operaciones que serán canceladas",
    "verifyUnverifyTrades": "Confirmar/ Anular operaciones",
    "allSplitsAreVerified": "Todas las divisiones están verificadas",
    "someSplitsAreNotVerified": "Algunas de las divisiones no están verificadas",
    "errorCreatingTrades": "No se pueden crear operaciones",
    "table": {
      "account": "Cuenta",
      "accountType": "Tipo de cuenta del cliente",
      "custodianAccountNumber": "Número de cuenta del cliente",
      "type": "Tipo",
      "amount": "Importe",
      "currency": "Moneda",
      "security": "Seguridad",
      "securityTicker": "Ticker de seguridad",
      "securityName": "Nombre de seguridad",
      "settlementDays": "Días de liquidación",
      "exchange": "Intercambio",
      "settlementDate": "Fecha de liquidación",
      "state": "Estado",
      "pairedWith": "Acompañado de",
      "selectAll": "Seleccionar todas las operaciones para verificar/desmarcar",
      "selectAllTradesToCancel": "Seleccionar todas las operaciones para cancelar",
      "selectAllTradesToVerifyOrCancel": "Seleccionar todas las operaciones para verificar/desmarcar o cancelar",
      "verifiedAt": "Verificado",
      "actions": "Acciones"
    },
    "cancelSubTradeRequest": "Cancelar operación",
    "cancelSubTradeRequestSuccess": "Operación cancelada correctamente",
    "cancelSubTradeRequestError": "No se pudo cancelar la operación",
    "types": {
      "BUY": "Comprar",
      "SELL": "Vender"
    }
  },
  "tradePairsModal": {
    "modalTitle": "Pares que se crearon",
    "buys": "Compras",
    "pairedWith": "Acompañado de",
    "sells": "Ventas",
    "noPair": "Sin par",
    "totalBuys": "Importe total en dólares de las compras",
    "totalSells": "Importe total en dólares de las ventas",
    "sellAll": "Vender todo"
  },
  "inherited": " - (heredado)",
  "includePendingTrades": "Incluir operaciones pendientes",
  "pendingTransfers": {
    "title": "Transacciones pendientes",
    "details": "Detalles de la transacción",
    "cancelTransaction": "Cancelar transacción",
    "cancelScheduledTransaction": "Cancelar programación",
    "types": {
      "WITHDRAW": "Retirar",
      "DEPOSIT": "Depositar"
    },
    "states": {
      "INITIATED": "Iniciado",
      "READY": "Listo",
      "REQUESTED": "Solicitado",
      "PROCESSING": "Procesando",
      "ACTIVE": "Activo",
      "REVIEWING": "Revisando",
      "RECONCILED": "Reconciliado",
      "FAILED": "Falló",
      "CANCELED": "Cancelado"
    }
  },
  "beneficiaryCrud": {
    "beneficiaryName": "Nombre del beneficiario",
    "relationshipToAccountHolder": "Relación con el titular de la cuenta",
    "allocation": "Asignación",
    "addAffiliate": "Añadir afiliado",
    "allocationError": "La asignación total debe ser igual al 100 %"
  },
  "householdMembers": {
    "title": "Miembros"
  },
  "changeTheme": {
    "portfolioTheme": "Tema de la cartera",
    "modelPortfolio": "Cartera modelo",
    "suggested": "Sugerido",
    "unset": "Desactivado",
    "save": "Guardar cambios",
    "noOptionsAvailable": "No hay carteras modelo disponibles",
    "noSuitabilityScore": "Debe responder a todas las preguntas sobre idoneidad antes de poder elegir un tema",
    "modelPortfolioRequired": "Se requiere una cartera modelo"
  },
  "recentTransactions": {
    "title": "Detalles de inversiones recientes"
  },
  "newsAndInsights": {
    "title": "Noticias y perspectivas"
  },
  "contacts": {
    "title": "Póngase en contacto con su asesor"
  },
  "accessToEntity": {
    "title": "Acceso",
    "table": {
      "name": "Nombre",
      "email": "Correo electrónico",
      "accessType": "Tipo de acceso",
      "relation": "Relación"
    },
    "accessTypes": {
      "fullAccess": "Acceso total",
      "limitedAccess": "Acceso limitado"
    },
    "oraganizationAccessRow": "Usuarios con acceso a las entidades {{org}}.",
    "relations": {
      "ADVISOR": "Asesor",
      "OTHER": "Otros",
      "OWNER": "Cliente (propietario)",
      "POWER_OF_ATTORNEY": "Poder notarial"
    },
    "editButton": {
      "title": "Editar acceso a {{entityName}}",
      "update": "Actualizar"
    },
    "addButton": {
      "formTitle": "Conceder acceso a {{entityName}}",
      "relationLabel": "Relación",
      "grantAccessButton": "Conceder acceso",
      "orgUserSearchText": "Usuario",
      "entitySearchText": "Entidades",
      "accounts": "Cuentas",
      "allowAccessToSpecificAccounts": "Permitir el acceso solo a cuentas específicas",
      "noAccountsSelectedError": "No se han seleccionado cuentas específicas: este usuario no tendrá acceso bajo esta entidad",
      "toggle": {
        "create": "Crear nuevo usuario",
        "invite": "Invitar a un usuario existente"
      },
      "createTab": {
        "firstName": "Nombre",
        "lastName": "Apellido",
        "relation": "Relación",
        "email": "Correo electrónico",
        "organization": "Organización",
        "role": "Rol",
        "roleToAccessEntity": "Rol para acceder a la entidad",
        "noRoleSelected": "Si no se selecciona ninguna función, el acceso se concederá en función de la función del usuario de la organización.",
        "autoInviteUser": "Invitar automáticamente al usuario",
        "emailError": "Este usuario ya existe. Invite al usuario existente."
      }
    },
    "confirmationModal": {
      "title": "¿Está seguro?",
      "bodyText": "¿Está seguro de que desea eliminar el acceso de {{orgUserName}} al perfil {{entityName}}?"
    }
  },
  "additionalInfoModal": {
    "title": "¿Qué significa esto?"
  },
  "viewAllProfilesDialog": {
    "switchProfile": "Cambiar perfil",
    "viewDetails": "Ver detalles",
    "addNewEntity": "Añadir nuevo perfil"
  },
  "translatableString": {
    "errorText": "Campo faltante"
  },
  "subTradeRequestTableDialog": {
    "title": "¿Está seguro de que desea cancelar esta solicitud de transacción?"
  },
  "exportConfiguration": {
    "title": "Configuración de exportación",
    "useAdditionalFilter": "Aplicar filtro a la exportación",
    "mainColumns": "Columnas principales",
    "additionalColumns": "Columnas adicionales",
    "selectAllColumns": "Seleccionar todas las columnas",
    "exportButton": "Exportar",
    "dateRange": "Intervalo de fechas",
    "fromDate": "Desde la fecha",
    "toDate": "Hasta la fecha",
    "specifyDateRange": "Especificar rango de fechas",
    "dateRangeError": "El intervalo de fechas no puede superar los {{days}} días",
    "maxDateRange": "El intervalo máximo es de {{days}} días",
    "futureDateError": "La fecha no puede ser futura",
    "startDateAfterEndError": "La fecha de inicio no puede ser posterior a la fecha de finalización",
    "bothDatesRequiredError": "Introduzca las fechas Desde y Hasta, o borre ambas.",
    "invalidDateError": "Fecha no válida",
    "fileName": "Nombre del archivo"
  },
  "dateRangeField": {
    "from": "Desde",
    "to": "A",
    "clear": "Borrar",
    "apply": "Aplicar"
  },
  "downloadButton": {
    "failedDownloadMessage": "Archivo no descargado",
    "progressModalTitle": "Preparando la exportación",
    "download": "Descargar",
    "exportProgressPercent": "{{percent}}%",
    "noExportsFound": "No se encontraron exportaciones",
    "recentExports": "Exportaciones recientes",
    "createExport": "Crear exportación",
    "exportColumnsCount_one": "{{count}} columna",
    "exportColumnsCount_other": "{{count}} columnas",
    "exportRefetchTimeout": "La exportación se inició pero no apareció en la lista. Actualice y vuelva a intentarlo."
  },
  "searchSecuritiesField": {
    "nothingFoundMessage": "No se han encontrado valores con ese ticker."
  },
  "marketValueChart": {
    "netContributions": "Contribuciones netas:"
  },
  "view": "Ver",
  "fundFacts": "Datos del fondo",
  "ruleBuilder": {
    "addRule": "Añadir regla",
    "addGroup": "Añadir grupo",
    "removeRuleGroup": "Eliminar grupo",
    "noAvailableRules": "No hay campos disponibles para este tipo de objeto. Añada un campo personalizado para poder crear una condición.",
    "and": "Y",
    "or": "O",
    "operators": {
      "equals": "Igual",
      "notEquals": "No es igual",
      "contains": "Contiene",
      "notContains": "No contiene",
      "startsWith": "Comienza con",
      "endsWith": "Termina con",
      "greaterThan": "Mayor que",
      "greaterThanOrEquals": "Mayor o igual que",
      "lessThan": "Menor que",
      "lessThanOrEquals": "Menor o igual que",
      "in": "En",
      "notIn": "No en",
      "exists": "Existe",
      "notExist": "No existe",
      "isEmpty": "Está vacío",
      "isNotEmpty": "No está vacío",
      "isTrue": "Es verdadero",
      "isFalse": "Es falso",
      "isBefore": "Es antes",
      "isAfter": "Es después",
      "includes": "Incluye",
      "notIncludes": "No incluye"
    }
  },
  "rules": {
    "state": "Estado",
    "marketValue": "Valor de mercado",
    "age": "Edad",
    "dateOfBirth": "Fecha de nacimiento",
    "accountType": "Tipo de cuenta",
    "createdAt": "Creado en"
  },
  "fieldErrors": {
    "default": "{{fieldName}} obligatorio",
    "phone": "Por favor, introduzca un número de teléfono válido",
    "email": "Por favor, introduzca una dirección de correo electrónico válida",
    "selectionTile": "Por favor, seleccione una opción",
    "address": "Por favor, introduzca una dirección completa"
  },
  "productShelf": {
    "exportHeaders": {
      "ticker": "Ticker",
      "name": "Nombre",
      "exchange": "Intercambio",
      "primaryAssetClass": "Clase de activos primarios",
      "secondaryAssetClass": "Clase de activos secundarios",
      "substitute": "Producto sustitutivo",
      "taxRank": "Clasificación fiscal",
      "tradeSchedule": "Calendario comercial",
      "currency": "Moneda",
      "currentPrice": "Precio actual",
      "originalCurrency": "Moneda original",
      "originalPrice": "Precio original",
      "autoUpdatePrice": "Actualizar el precio de forma automática",
      "historyDate": "Historial de fechas",
      "priceHistory": "Historial de precios",
      "holdingsQuantityHistory": "Historial de cantidades en cartera",
      "holdingsValueHistory": "Historial del valor de las participaciones",
      "cusip": "CUSIP",
      "fundSeries": "Serie de fondos",
      "volatile": "Volátil",
      "isPartial": "Fraccional",
      "tertiaryAssetClass": "Clase de activos terciarios",
      "waivedFeePercentage": "Porcentaje de exención de tasas",
      "settlementDays": "Días de liquidación",
      "url": "URL",
      "isin": "ISIN",
      "ric": "RIC",
      "type": "Tipo",
      "multiplier": "Multiplicador"
    },
    "exportConfig": {
      "includeHistory": "Incluir historial de precios",
      "historyFrom": "Historial desde",
      "historyTo": "Historial a",
      "progressTitle": "Exportación de datos del estante de productos"
    }
  },
  "featureFlags": {
    "inheritedSetTo": "Heredado establecido en",
    "true": "Sí",
    "false": "No"
  },
  "updateTransferModal": {
    "title": "Actualizar transferencia",
    "source": "Fuente",
    "amount": "Importe",
    "type": "Tipo",
    "updatedToastMessage": "La transferencia se ha actualizado."
  },
  "modelPortfolioHolding": {
    "noPortfolioHolding": "No hay desglose de participaciones disponible",
    "errorStateTitlePortfolioHolding": "No se puede cargar el desglose de participaciones"
  },
  "holdings": {
    "noHoldings": "No tiene ninguna participación",
    "errorStateTitleHoldings": "No se pueden cargar las existencias",
    "searchPlaceholder": "Buscar participaciones",
    "noMatchingHoldings": "Ninguna participación coincide con su búsqueda"
  },
  "affiliateConversion": {
    "inviteUser": "Invitar usuario",
    "edit": "Editar",
    "delete": "Eliminar",
    "confirmation": {
      "title": "¿Está seguro?",
      "subTitle": "Por favor, confirme que está asignando el usuario de entidad correcto ({{entityUserEmail}})"
    }
  },
  "usaContributionTypes": {
    "REGULAR": "Regular",
    "EMPLOYEE": "Empleado",
    "EMPLOYER": "Empleador",
    "RECHARACTERIZATION": "Recaracterización",
    "ROLLOVER_60_DAY": "Renovación de 60 días",
    "ROLLOVER_DIRECT": "Transferencia directa",
    "TRANSFER": "Transferencia",
    "TRUSTEE_FEE": "Honorarios del fideicomisario",
    "CONVERSION": "Conversión",
    "REPAYMENT": "Reembolso"
  },
  "usaContributionTypeTitle": "Tipo de contribución",
  "fiscalYearTitle": "Año fiscal",
  "clientSelect": {
    "affiliate": "Afiliado",
    "selectUser": "Seleccionar usuario"
  },
  "usaWithdrawalReasons": {
    "IRA_DISTRIBUTION_TYPE_UNKNOWN": "Tipo de distribución IRA desconocido",
    "NORMAL": "Normal",
    "DISABILITY": "Discapacidad",
    "SOSEPP": "Sosepp",
    "PREMATURE": "Prematuro",
    "DEATH": "Muerte",
    "EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE": "Eliminación del exceso de contribución antes de la fecha límite fiscal",
    "EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE": "Eliminación del exceso de contribución después de la fecha límite fiscal",
    "ROLLOVER_TO_QUALIFIED_PLAN": "Transferencia a un plan calificado",
    "ROLLOVER_TO_IRA": "Transferencia a una cuenta IRA",
    "DISTRIBUTION_TRANSFER": "Transferencia de distribución",
    "RECHARACTERIZATION_PRIOR_YEAR": "Recaracterización del ejercicio anterior",
    "RECHARACTERIZATION_CURRENT_YEAR": "Recaracterización del año actual",
    "DISTRIBUTION_CONVERSION": "Conversión de distribución",
    "MANAGEMENT_FEE": "Comisión de gestión",
    "PLAN_LOAN_401_K": "Préstamo del plan 401K",
    "PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS": "Cuenta IRA simple prematura, menos de 2 años",
    "NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS": "Cuenta Roth IRA normal, más de 5 años"
  },
  "usaWithdrawalReasonTitle": "Motivo de la retirada",
  "stateTaxMessages": {
    "info": {
      "mandatory": "{{state}} exige la retención del impuesto estatal (mínimo {{minTaxWithholding}} %) cuando se retiene el impuesto federal. Si está exento de la retención federal, puede optar por no participar. Si decide participar, se seguirá aplicando el mínimo.",
      "mandatoryOptOut": "{{state}} exige la retención del impuesto estatal (mínimo {{minTaxWithholding}} %) cuando se retiene el impuesto federal. Se necesita un formulario específico del estado para optar por no participar, pero actualmente esto no es posible. Si está exento de la retención federal, puede optar por no participar. Si decide participar en la retención, se seguirá aplicando el mínimo.",
      "noElection": "{{state}} no permite la retención del impuesto estatal sobre la renta para las distribuciones de cuentas IRA.",
      "voluntaryWithMinimum": "En el caso de {{state}}, no es necesario retener fondos para el impuesto estatal. Sin embargo, si decide realizar la retención, el mínimo es del {{minTaxWithholding}} %.",
      "voluntary": "Para {{state}}, no es necesario retener fondos para la retención de impuestos estatales.",
      "stateSpecific": {
        "DC": "En el caso de {{state}}, no es necesario retener fondos para el impuesto estatal si no cierra completamente su cuenta IRA. Sin embargo, si cierra completamente su cuenta IRA, se requiere un mínimo del {{minTaxWithholding}} %.",
        "CA": "En el caso de {{state}}, no es necesario retener fondos para el impuesto estatal. Sin embargo, si decide realizar la retención, el mínimo es el {{minTaxWithholding}} % de su retención del impuesto federal.",
        "VT": "{{state}} exige la retención del impuesto estatal cuando se retiene el impuesto federal. El mínimo es el {{minTaxWithholding}} % de su retención del impuesto federal.",
        "MS": "La ley de {{state}} exige la retención de impuestos estatales solo sobre las distribuciones de cuentas Roth IRA que se consideren retiros prematuros o excesivos. No se permite la retención voluntaria. No podemos determinar si su distribución específica cumple con estos criterios. Para saber si se requiere la retención de impuestos estatales para su retiro, comuníquese con su asesor."
      }
    },
    "validation": {
      "minTaxWithholding": "Debe retener al menos el {{minTaxWithholding}} % en concepto de retención del impuesto estatal.",
      "optOutOrMinTaxWithholding": "La tasa de retención de impuestos estatales debe ser del {{optOutTaxWithholding}} % o superior al {{minTaxWithholding}} %"
    }
  },
  "tableColumnDescriptions": {
    "localCost": "El costo del valor por acción en la moneda en la que se ejecutó",
    "localBookValue": "El costo total del valor en la moneda en la que se ejecutó",
    "nativeCost": "El costo nativo del valor por acción convertido a la moneda nativa de la cuenta",
    "nativeBookValue": "El costo total del valor convertido a la moneda nativa de la cuenta",
    "custodianBookValue": "El valor contable de las tenencias según lo informado por el custodio",
    "fxRate": "Tipo de cambio histórico utilizado durante el intercambio para comprar el valor"
  },
  "tableColumns": {
    "account": "Cuenta",
    "type": "Tipo",
    "source": "Fuente",
    "state": "Estado",
    "createdAt": "Creado el",
    "value": "Valor",
    "scheduledAt": "Fecha",
    "securityName": "Nombre del valor",
    "frequency": "Frecuencia",
    "bankAccountInstitution": "Número de institución de la cuenta bancaria",
    "bankAccountTransitNumber": "Número de tránsito de la cuenta bancaria",
    "bankAccountNumber": "Número de cuenta bancaria",
    "accountId": "ID de cuenta",
    "firstName": "Nombre del usuario",
    "lastName": "Apellido del usuario",
    "currency": "Moneda",
    "subAccount": "Subcuenta",
    "goal": "Meta",
    "user": "Usuario",
    "organization": "Organización",
    "householdClientGroup": "Grupo de clientes domésticos",
    "symbol": "Símbolo",
    "quantity": "Cantidad",
    "bookCost": "Costo del libro",
    "currentPrice": "Precio actual",
    "unrealizedGainLoss": "G/P no realizadas",
    "oneDayChange": "Cambio en 1 día",
    "percentOfTotal": "% del total",
    "marketValueNative": "Valor de mercado (nativo)",
    "marketValue": "Valor de mercado",
    "name": "Nombre",
    "holder": "Titular",
    "nickname": "Apodo",
    "accountNumber": "Número de cuenta",
    "program": "Programa",
    "currentValue": "Valor actual",
    "amount": "Importe",
    "nextScheduledDate": "Próxima fecha programada",
    "costPrice": "Precio de costo",
    "date": "Fecha",
    "accountGroupName": "Nombre del grupo de cuentas",
    "numberOfAccounts": "Número de cuentas",
    "security": "Seguridad",
    "assetClass": "Clase de activos",
    "taxRank": "Clasificación fiscal",
    "targetPercentage": "% objetivo",
    "actualPrice": "Precio real",
    "actualQuantity": "Cantidad real",
    "expectedPrice": "Precio esperado",
    "expectedQuantity": "Cantidad esperada",
    "reconciledAt": "Reconciliado",
    "repCode": "Código de representante",
    "cusip": "CUSIP"
  },
  "holdingsExchangeRate": "Tipo de cambio: 1 {{fromCurrency}} = {{rate}} {{toCurrency}}",
  "datePicker": {
    "cancelButtonLabel": "Cancelar",
    "okButtonLabel": "Aceptar",
    "datePickerDefaultToolbarTitle": "Seleccionar fecha",
    "dateTimePickerDefaultToolbarTitle": "Seleccionar fecha y hora"
  },
  "fieldValidation": {
    "required": "Por favor, rellene este campo.",
    "enterNumber": "Por favor, introduzca un número."
  },
  "customFieldsDisplay": {
    "noCustomFields": "Usted no tiene ningún campo personalizado"
  },
  "accountGroups": {
    "noAccountGroupsExist": "No existen grupos de cuentas",
    "errorFetchingAccountGroups": "No se pueden cargar los grupos de cuentas"
  },
  "householdModelPortfolio": {
    "initialize": "Inicializar",
    "edit": "Editar",
    "tabs": {
      "model": "Modelo",
      "ips": "IPS"
    },
    "noIpsFieldsConfigured": "No hay campos IPS configurados",
    "ipsContentPending": "El contenido de IPS aparecerá aquí cuando los campos configurados estén habilitados.",
    "noAccess": "No tiene permiso para ver carteras modelo.",
    "error": "No se pudo cargar la cartera modelo del hogar.",
    "modelDetails": {
      "title": "Detalles del modelo",
      "noModelAttached": "Aún no se ha adjuntado ninguna cartera modelo a este hogar.",
      "error": "No se pudieron cargar los detalles del modelo."
    },
    "allocation": {
      "error": "No se pudo cargar la asignación de activos.",
      "noSecurities": "Aún no hay valores asignados a esta cartera modelo."
    },
    "ips": {
      "error": "No se pudo cargar el contenido de IPS.",
      "noTargetAllocations": "Aún no hay asignaciones objetivo configuradas para esta cartera modelo."
    }
  },
  "householdPortfolio": {
    "attachModel": "Adjuntar modelo",
    "selectTheme": "Tema",
    "selectModel": "Cartera modelo",
    "attachModelSuccess": "Modelo adjunto",
    "attachModelError": "No se pudo adjuntar el modelo. Inténtelo de nuevo.",
    "noModelAttached": "Aún no se ha adjuntado ninguna cartera modelo a este hogar. Adjunte una para ver la cartera.",
    "managePortfolio": "Administrar cartera del hogar",
    "detachModel": "Desvincular modelo",
    "detachModelTitle": "¿Desvincular modelo del hogar?",
    "detachModelBody": "Esto elimina la cartera modelo del hogar. La pestaña de cartera estará vacía hasta que se adjunte un nuevo modelo. Se borrarán las anulaciones de asignación personalizadas.",
    "detachModelSuccess": "Modelo desvinculado",
    "detachModelError": "No se pudo desvincular el modelo. Inténtelo de nuevo.",
    "tradingProcess": "Proceso de negociación",
    "updateSuccess": "Cartera del hogar actualizada",
    "updateError": "No se pudo actualizar la cartera del hogar. Inténtelo de nuevo.",
    "tradingProcessRequired": "Seleccione un proceso de negociación",
    "portfolioStillBeingPrepared": "La cartera del hogar aún se está preparando. Inténtelo de nuevo en un momento.",
    "methodology": "Metodología de asignación",
    "unified": "Unificada",
    "customized": "Personalizada",
    "errors": {
      "generic": "Algo salió mal. Inténtelo de nuevo.",
      "NOT_CUSTOMIZED": "Este informe no está en modo personalizado. Actualizando…",
      "WRONG_REPORT_MEMBER": "El conjunto de miembros ha cambiado. Actualizando el informe…",
      "PRODUCT_NOT_HELD": "Este valor no se mantiene en esta cuenta.",
      "CAPACITY_BREACH": "La asignación debe estar entre el 0 % y el 100 %.",
      "WEIGHT_SUM_OUT_OF_RANGE": "Las asignaciones de esta cuenta no suman correctamente.",
      "AMOUNT_SUM_OUT_OF_RANGE": "Los importes en dólares de esta cuenta no suman correctamente.",
      "AGGREGATE_CONSERVATION": "Los totales del hogar no coinciden con el objetivo del modelo.",
      "BAD_USER_INPUT": "No hay cambios para guardar.",
      "SOLVE_FAILED": "No se pudieron reequilibrar los objetivos desbloqueados. Intente ajustar sus anulaciones.",
      "NOT_ACCESSIBLE": "Las asignaciones personalizadas requieren más de una cuenta de miembro negociable.",
      "PORTFOLIO_RESTRICTED": "Las carteras del hogar no están habilitadas para esta organización.",
      "LOCKS_INFEASIBLE": "Los bloqueos actuales y las tenencias de cuenta disponibles no pueden satisfacer los objetivos del hogar."
    },
    "modelAttachedNoMembers": "Se ha adjuntado una cartera modelo. La cartera del hogar aparecerá una vez que este hogar tenga al menos una subcuenta.",
    "inheritedFromHousehold": "Esta cuenta hereda la cartera modelo del hogar.",
    "goalInheritedFromHousehold": "Esta meta hereda la cartera modelo del hogar.",
    "goalLoadFailedName": "Meta seleccionada",
    "goalLoadFailed": "No se pudieron cargar los detalles de la cartera del hogar de esta meta. Seleccione un tema y un modelo manualmente, o inténtelo de nuevo más tarde.",
    "unitDollar": "$",
    "unitPercent": "%",
    "unit": "Unidad de entrada",
    "customTarget": "Objetivo personalizado",
    "customTargetInputLabel": "Objetivo personalizado para {{security}} en {{member}}",
    "recalculate": "Recalcular",
    "save": "Guardar",
    "unsavedChangesTitle": "¿Descartar cambios?",
    "unsavedChangesBody": "Tiene cambios de asignación sin guardar. ¿Desea descartarlos?",
    "unsavedAllocationGateTitle": "Cambios de asignación sin guardar",
    "unsavedAllocationGateBody": "Tiene cambios de asignación personalizados sin guardar. Puede continuar sin guardar, o volver y guardar primero.",
    "proceedWithoutSaving": "Continuar sin guardar",
    "goBackAndSaveFirst": "Volver y guardar primero",
    "resetCustomTargets": "Restablecer",
    "resetCustomTargetsTitle": "¿Restablecer objetivos personalizados?",
    "saveCustomAllocationsSuccess": "Objetivos personalizados guardados",
    "resetCustomAllocationsSuccess": "Objetivos personalizados restablecidos",
    "advisoryViolations": {
      "WEIGHT_SUM": "Objetivos personalizados resaltados: las asignaciones de valores de una o más cuentas no suman el total invertible (excluyendo efectivo). Ajuste sus anulaciones o bloquee menos celdas, luego Recalcule.",
      "ROW_DRIFT": "Objetivos personalizados resaltados: el total de fondos de un hogar no coincide con el objetivo del modelo. Ajuste los valores bloqueados o cambie las celdas que anula.",
      "MULTIPLE": "Algunos objetivos personalizados recalculados están resaltados porque no se equilibran con sus anulaciones o un valor supera su peso en la clase de activos. Revise los campos resaltados o ajuste los valores bloqueados, luego Recalcule. Guardar permanece deshabilitado mientras un valor supere su peso en la clase de activos.",
      "CAPACITY": "Objetivos personalizados resaltados: un valor supera su peso en la clase de activos en una cuenta. Redúzcalo o mueva el exceso a otra cuenta, luego Recalcule. Guardar permanece deshabilitado hasta entonces."
    },
    "customTargetNotHeld": "Esta cuenta no tiene este fondo",
    "customTargetNotTradeable": "Esta cuenta no es negociable (inactiva, pendiente de aprobación o cerrada), por lo que sus objetivos personalizados no se pueden editar",
    "inactiveMembersInTotalsNotice": "Este hogar incluye miembros inactivos o pendientes de aprobación. Recalcular y Guardar los excluye, y sus objetivos personalizados no se pueden editar; active \"Ver subcuentas inactivas\" para verlos.",
    "resetCustomTargetsBody": "Esto restablece los objetivos personalizados de todos los miembros negociables al modelo del hogar. Se perderán las ediciones no guardadas.",
    "capacityLimit": "Cada valor puede ser como máximo el {{max}}% de una cuenta en este modelo de clase de activos. Reduzca este importe o mueva el resto a otra cuenta.",
    "percentageOutOfRange": "Ingrese un porcentaje entre 0 y 100",
    "tradeNotHeld": "Esta cuenta no tiene este fondo, por lo que no hay nada que negociar",
    "tradeNotTradeable": "Esta cuenta no es negociable, por lo que no se pueden introducir operaciones"
  },
  "errorPortfolioViewUnderHousehold": "La cartera modelo está asignada al hogar. Por favor, véala en la página del hogar.",
  "errorPortfolioViewUnderSubAccounts": "Las carteras modelo se asignan a nivel de subcuenta. Por favor, véalas en las páginas de subcuentas relevantes.",
  "errorPortfolioStillBeingPrepared": "La cartera aún se está preparando. Por favor, inténtelo de nuevo en un momento.",
  "errorPortfolioNoModelAssigned": "No hay ninguna cartera modelo asignada a este nivel.",
  "autocomplete": {
    "noOptions": "Sin resultados",
    "loading": "Buscando…",
    "typeToSearch": "Escriba para buscar",
    "minChars": "Escriba al menos {{count}} caracteres",
    "loadingMore": "Cargando más…"
  },
  "driftSettings": {
    "label": "Política de desviación efectiva: {{method}} ±{{tolerance}}%",
    "inheritedFromModelPortfolio": " (heredado de la cartera modelo)"
  },
  "optimizerEmptyRun": {
    "internalDriftAdvisory": "Esta cartera tiene una desviación interna dentro de una clase de activos. La desviación interna es solo consultiva y no activa el reequilibrio automático de la desviación. Utilice Autocompletar para el objetivo o introduzca las operaciones manualmente.",
    "notDriftEligible": "Esta cartera no es elegible para la desviación — está dentro de la banda de tolerancia de desviación a nivel de selección, por lo que el optimizador no propuso operaciones.",
    "notProcessed": "El optimizador no procesó esta cartera para esta ejecución.",
    "pendingTrades": "Las operaciones aún están pendientes en esta cartera."
  },
  "viewPortfolioWideTargetPercentages": "Mostrar % objetivo de toda la cartera",
  "advisorContact": {
    "loading": "Cargando contacto del asesor…",
    "loadFailed": "No se pudo cargar la información de contacto del asesor."
  },
  "accountAllocationGrid": {
    "fundColumn": "Fondo",
    "householdActualColumn": "Real del hogar %",
    "readOnlyAccount": "Solo lectura",
    "nonTradeableNote": "Las cuentas inactivas o pendientes de aprobación no se pueden asignar hasta que estén activas.",
    "cellLocked": "Bloqueado",
    "cellUploaded": "Cargado",
    "releaseCell": "Desbloquear {{security}} para {{account}}",
    "undo": "Deshacer",
    "recalculate": "Recalcular",
    "legend": {
      "label": "Leyenda de celdas",
      "locked": "Editado por usted",
      "uploaded": "Cargado desde CSV"
    },
    "csvTemplate": {
      "securityColumn": "Valor",
      "fundIdColumn": "ID de fondo",
      "filename": "Plantilla de asignación por cuenta"
    },
    "csvUpload": {
      "upload": "Cargar archivo CSV",
      "modalTitle": "Importar archivo CSV",
      "modalDescription": "Importe un archivo CSV para actualizar la asignación de las cuentas. Parta de la plantilla para que cada cuenta y cada fondo coincidan. Solo se actualizan los valores que usted cambie.",
      "import": "Importar archivo",
      "success_one": "Se actualizó {{count}} celda desde el CSV.",
      "success_other": "Se actualizaron {{count}} celdas desde el CSV.",
      "nothingChanged": "El archivo coincide con la cuadrícula, así que no cambió nada.",
      "errorTitle": "No se puede cargar este archivo",
      "errorIntro": "No cambió nada. Corrija estos problemas en el archivo y vuelva a cargarlo.",
      "warningTitle": "Revise esta carga",
      "warningIntro": "Importar aplica el resto del archivo.",
      "blankAccount": "(en blanco)",
      "issues": {
        "WRONG_FILE_TYPE": "Solo se pueden cargar archivos CSV.",
        "FILE_TOO_LARGE": "Este archivo supera los {{maxMb}} MB.",
        "UNREADABLE_FILE": "No se pudo leer este archivo como CSV. Parta de la plantilla descargada e inténtelo de nuevo.",
        "TOO_MANY_ROWS": "Este archivo tiene más de {{maxRows}} filas de fondos.",
        "NO_ACCOUNT_COLUMNS": "Este archivo no tiene columnas de cuentas. Parta de la plantilla descargada.",
        "UNKNOWN_ACCOUNT": "Columna {{column}}: la cuenta {{accountNumber}} no pertenece a este hogar.",
        "READ_ONLY_ACCOUNT": "Columna {{column}}: la cuenta {{accountNumber}} es de solo lectura, así que no se puede cargar.",
        "DUPLICATE_ACCOUNT": "Columna {{column}}: la cuenta {{accountNumber}} aparece más veces que en la cuadrícula.",
        "DUPLICATE_FUND": "Fila {{row}}: {{fund}} aparece más de una vez.",
        "INVALID_VALUE": "Fila {{row}}: \"{{value}}\" para {{fund}} en la cuenta {{accountNumber}} no es un número. Ingrese un porcentaje, por ejemplo 12.5.",
        "VALUE_OUT_OF_RANGE": "Fila {{row}}: {{value}} para {{fund}} en la cuenta {{accountNumber}} no está entre 0 y 100.",
        "FUND_NOT_HELD": "Fila {{row}}: la cuenta {{accountNumber}} no tiene {{fund}}, así que deje el valor en 0 o en blanco.",
        "UNKNOWN_FUND": "Fila {{row}}: {{fund}} no está en el modelo de este hogar, así que se omitirá la fila.",
        "FUND_MATCHED_BY_TICKER": "Fila {{row}}: no se encontró el ID de fondo {{value}}, así que {{fund}} se asoció por su símbolo.",
        "MISSING_ACCOUNT": "La cuenta {{accountNumber}} no tiene columna, así que sus celdas no cambiarán."
      }
    },
    "comparison": {
      "proposedColumn": "Propuesto",
      "currentColumn": "Actual",
      "changedFrom": "Cambió de {{current}} a {{proposed}}",
      "fundsOffTarget": "Los valores de mercado cambiaron desde la edición, por lo que estos fondos están fuera de su objetivo del hogar: {{funds}}. Las asignaciones se aplican tal como se firmaron y pueden reequilibrarse después."
    },
    "householdTargetColumn": "Objetivo del hogar %"
  },
  "modelPortfolioSearchField": {
    "searchFailed": "No se pudieron buscar carteras modelo.",
    "emptyList": "Ninguna cartera modelo coincide con esta búsqueda."
  },
  "securitySearchSelect": {
    "searchFailed": "No se pudo buscar en el estante de productos.",
    "emptyList": "Ningún valor coincide con esta búsqueda."
  },
  "createdFrom": "Creado desde",
  "createdTo": "Creado hasta"
}
